import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule, LOCALE_ID } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
// import { NgxMaskModule } from "ngx-mask";
import { ToastrModule } from "ngx-toastr";
import { AppRoutingModule } from "src/app/app.routes";
import { SimpleHtmlModule } from "src/app/components/simple-html/simple-html.module";
import { DirectiveModule } from "src/app/directive/directives.module";
import { MaterialMarketingModule } from "src/app/pages/material-marketing/material-marketing.module";
import { CatalogDynamicMenuComponent } from "./components/catalog-dynamic-menu/catalog-dynamic-menu.component";
import { CatalogDynamicDropdownComponent } from "./components/catalog-dynamic-dropdown/catalog-dynamic-dropdown.component";
import { CatalogItemComponent } from "./components/catalog-item/catalog-item.component";
import { CatalogItemLineComponent } from "./components/catalog-item-line/catalog-item-line.component";
import { CatalogDropdownComponent } from "./components/catalog-dropdown/catalog-dropdown.component";
import { CatalogMenuComponent } from "./components/catalog-menu/catalog-menu.component";
import { CatalogMenuClickComponent } from "./components/catalog-menu-click/catalog-menu-click.component";
import { CatalogCartComponent } from "./components/catalog-cart/catalog-cart.component";
import { CatalogDynamicMenuClickComponent } from "./components/catalog-dynamic-menu-click/catalog-dynamic-menu-click.component";
import { PageCatalogComponent } from "./pages/page-catalog/page-catalog.component";
import { ProductQuantityInputComponent } from "./components/product-quantity-input/product-quantity-input.component";
import { provideNgxMask, NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { ProductImageComponent } from "./components/product-image/product-image.component";
import { ProductModule } from "../product/product.module";
import { CatalogFilterComponent } from "./components/catalog-filter/catalog-filter.component";
import { MatIconModule } from "@angular/material/icon";
// import { NgxSliderModule } from "@angular-slider/ngx-slider";
import localePt from "@angular/common/locales/pt";
import { defineLocale } from "ngx-bootstrap/chronos";
import { ptBrLocale } from "ngx-bootstrap/locale";
import { registerLocaleData } from "@angular/common";
import { ShowDetailsComponent } from "src/app/components/show-details/show-details.component";

const customLocale = {
  ...ptBrLocale,
  weekdays: [$localize`Domingo`, $localize`Segunda-feira`, $localize`Terça-feira`, $localize`Quarta-feira`, $localize`Quinta-feira`, $localize`Sexta-feira`, $localize`Sábado`],
  weekdaysShort: [$localize`Dom`, $localize`Seg`, $localize`Ter`, $localize`Qua`, $localize`Qui`, $localize`Sex`, $localize`Sáb`],
  months: [
    $localize`Janeiro`, $localize`Fevereiro`, $localize`Março`, $localize`Abril`, $localize`Maio`, $localize`Junho`,
    $localize`Julho`, $localize`Agosto`, $localize`Setembro`, $localize`Outubro`, $localize`Novembro`, $localize`Dezembro`
  ],
  monthsShort: [$localize`Jan`, $localize`Fev`, $localize`Mar`, $localize`Abr`, $localize`Mai`, $localize`Jun`, $localize`Jul`, $localize`Ago`, $localize`Set`, $localize`Out`, $localize`Nov`, $localize`Dez`],
};


defineLocale("pt-custom", customLocale);
registerLocaleData(localePt, "pt-BR");

@NgModule({
  declarations: [
    PageCatalogComponent,
    CatalogItemComponent,
    CatalogCartComponent,
    CatalogItemLineComponent,
    CatalogMenuComponent,
    CatalogDynamicDropdownComponent,
    CatalogDynamicMenuComponent,
    CatalogMenuClickComponent,
    CatalogDropdownComponent,
    CatalogDynamicMenuClickComponent,
    ProductQuantityInputComponent,
    ShowDetailsComponent,
    ProductImageComponent,
    CatalogFilterComponent,
  ],
  imports: [
    // NgxSliderModule,
    ProductModule,
    CommonModule,
    MaterialMarketingModule,
    HttpClientModule,
    BrowserModule,
    NgxMaskDirective,
    NgxMaskPipe,
    BrowserAnimationsModule,
    MatIconModule,
    AppRoutingModule,
    FormsModule,
    SimpleHtmlModule,
    ReactiveFormsModule,
    // PaginationModule.forRoot(),
    // BsDatepickerModule.forRoot(),
    SweetAlert2Module.forRoot(),
    // TypeaheadModule.forRoot(),
    // TooltipModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: "toast-bottom-right",
    }),
    DirectiveModule,
  ],
  providers: [provideNgxMask(), { provide: LOCALE_ID, useValue: "pt-custom" }],
  exports: [ProductQuantityInputComponent],
})
export class CatalogModule { }
